import React, { Component } from "react";

class Title extends Component {
 	render() {
	    return (
			<div className="fram_cust full_width">
				<div className="container">
					<h1>Prints On Canvas</h1>
				</div>
			</div>
	    );
  	}
}

export default Title;